import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Wishlist API Module
 * 
 * Handles all wishlist-related API operations.
 * All endpoints require authentication.
 */

export const wishlistApi = {
  /**
   * Get user wishlist
   * @param {number} page - Page number for pagination
   * @returns {Promise} Wishlist data
   */
  async getWishlist(page = 1) {
    const response = await apiClient.get(apiEndpoints.wishlist.show, { params: { page } })
    return response.data
  },

  /**
   * Add product to wishlist
   * @param {number} productId - Product ID to add
   * @returns {Promise} Updated wishlist
   */
  async addItem(productId) {
    const response = await apiClient.post(apiEndpoints.wishlist.addItem, { product_id: productId })
    return response.data
  },

  /**
   * Remove product from wishlist
   * @param {number} productId - Product ID to remove
   * @returns {Promise} Updated wishlist
   */
  async removeItem(productId) {
    const response = await apiClient.delete(apiEndpoints.wishlist.removeItem(productId))
    return response.data
  },
}

export default wishlistApi
